<template>
  <div style="margin: 10px 10px;display: inline-block;" @click="handleClick()">
    <el-card class="box-card">
      <div slot="header" style="text-align: center;font-weight:bold;font-size:16px;">
        <span>{{title}}</span>
      </div>
      <div> <center> <img :src="imgUrl" style="width:320px;height:180px;"> </center></div>
      <div style="text-align: center;padding-top: 0px;color: gray;">{{time}}</div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    title : {type:String,default:""},
    detail: {type:String,default:""},
    time: {type:String,default:""},
    uid: {type:String,default:""},
    imgUrl : {type:String,default:"https://dummyimage.com/1600x900/ff6a00/fff"},
  },
  methods: {
    handleClick() {
      let path_txt = '/videoplay?uid='+this.uid;
      this.$router.push({path:path_txt})
      // console.log("demodetails");
    },
  }

};
</script>

<style lang="less" scoped>
  /deep/.el-card__header{ padding: 10px 20px;}
  /deep/.el-card__body{ padding: 10px 10px;}
  .el-card{ width:340px; height: 275px; border-radius:20px; }
</style>
